import { useContext } from 'react'

import Context from './Context'

export default () => {
  const ctx = useContext(Context)

  return ctx
}
